export interface TargetProject {
	id: string;
	name: string;
}
